// extracted by mini-css-extract-plugin
export default {"tickets-summary-stats-container":"styles_tickets-summary-stats-container__rrv5o"};